<ng-container>
  <hr class="d-none d-md-block m-8" />
  <nav id="my-page-menu-nav">
    <ng-container *ngIf="node$ | async as node; else loadingTemplate">
      <ul>
        <py-my-page-menu-list-item
          *ngFor="let item of node.children"
          [item]="item"
          [notificationCount]="getNotificationCountForLink(item.styleClasses) | async"
          class="my-2"
        ></py-my-page-menu-list-item>
      </ul>
    </ng-container>
  </nav>
</ng-container>

<ng-template #loadingTemplate>
  <div class="d-flex flex-column align-items-center">
    <div class="skeleton w-75 py-2 mb-2"></div>
    <div class="skeleton w-75 py-2 mb-2"></div>
    <div class="skeleton w-75 py-2 mb-2"></div>
  </div>
</ng-template>
